import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as APIS from "../../../../../services/apis";

export function* handleFetchCountries({ payload }) {
  try {
    const res = yield call(APIS.fetchAllCountries, payload);
    const { data } = res;
    yield put(actions.fetchCountriesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCountriesFailure(err?.response?.data));
  }
}

export function* handleFetchStates({ payload }) {
  try {
    const res = yield call(APIS.fetchAllStatesByCountryId, payload);
    const { data } = res;
    yield put(actions.fetchStatesSuccess(data));
  } catch (err) {
    yield put(actions.fetchStatesFailure(err?.response?.data));
  }
}

export function* handleFetchCities({ payload }) {
  try {
    const res = yield call(APIS.fetchAllCitiesByStateId, payload);
    const { data } = res;
    yield put(actions.fetchCitiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCitiesFailure(err?.response?.data));
  }
}

export function* handleFetchLabDetails({ payload }) {
  try {
    const res = yield call(APIS.fetchLabDetails, payload);
    const { data } = res;
    yield put(actions.fetchLabDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchLabDetailsFailure(err?.response?.data));
  }
}

export function* handleEditLab({ payload }) {
  try {
    const res = yield call(APIS.editLab, payload);
    const { data } = res;
    yield put(actions.updateLabSuccess(data));
    payload.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.updateLabFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.updateLabFailure(err?.response?.data));
    payload.onFailure();
  }
}
/**
 * Root saga manages watcher lifecycle
 */
export function* labEditSaga() {
  yield takeLatest(actions.fetchCountries.type, handleFetchCountries);
  yield takeLatest(actions.fetchStates.type, handleFetchStates);
  yield takeLatest(actions.fetchCities.type, handleFetchCities);
  yield takeLatest(actions.fetchLabDetails.type, handleFetchLabDetails);
  yield takeLatest(actions.updateLab.type, handleEditLab);
}
